<template>
  <div class="news-control">
    <!-- 弹窗 -->
    <div v-if="showTooltip" class="tooltip-overlay" @click="closeTooltip">
      <div class="tooltip-content" @click.stop>
        <div class="tooltip-header">
          <div class="tooltip-icon">💡</div>
          <h3>两种回答模式，随时切换</h3>
        </div>
        <p class="tooltip-description">根据妈妈的需求，选择最合适的回答方式</p>

        <div class="tooltip-modes">
          <div class="mode-card detailed-mode" @click="tryButton('detailed')">
            <div class="mode-icon">📋</div>
            <h4>详细版</h4>
            <p>原因分析+完整方法，适合想深入了解</p>
          </div>
          <div class="mode-card simplified-mode" @click="tryButton('simplified')">
            <div class="mode-icon">⚡</div>
            <h4>简化版</h4>
            <p>一句话说重点，适合快速获取建议</p>
          </div>
        </div>

        <div class="tooltip-buttons" v-if="selectedMode === 'detailed'">
          <button class="try-detailed-btn" @click="tryDetailedMode">试试详细版</button>
          <button class="got-it-btn" @click="closeTooltip">知道了 ✓</button>
        </div>
        <div class="tooltip-buttons" v-if="selectedMode === 'simplified'">
          <button class="try-simplified-btn" @click="trySimplifiedMode">试试简化版</button>
          <button class="got-it-btn" @click="closeTooltip">知道了 ✓</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted, watch, defineProps,onBeforeUnmount } from 'vue'
import { updateDefaultStyle } from '@/api/chat'

// 接收父组件传递的globalDefaultStyle
const props = defineProps({
  globalDefaultStyle: {
    type: [Number, null],
    default: null,
  },
})

// 控制弹窗显示
const showTooltip = ref(false)
// 控制选中的模式
const selectedMode = ref('detailed')
let openTooltipTimer = null

// 定义emit事件
const emit = defineEmits(['tooltip-shown', 'tooltip-closed'])

// 禁止背景滚动
const disableBodyScroll = () => {
  document.body.style.overflow = 'hidden'
  document.body.style.touchAction = 'none'
  // 阻止触摸事件默认行为
  // document.addEventListener('touchmove', preventDefault, { passive: false })
}

// 恢复背景滚动
const enableBodyScroll = () => {
  document.body.style.overflow = ''
  document.body.style.touchAction = ''
  // 移除触摸事件监听
  // document.removeEventListener('touchmove', preventDefault)
}

// 阻止默认触摸行为
// const preventDefault = (e) => {
//   e.preventDefault()
// }

// 打开弹窗
const openTooltip = () => {
  if (showTooltip.value) return
  showTooltip.value = true
  selectedMode.value = 'detailed'
  // 禁止背景滚动
  disableBodyScroll()
  // 通知父组件弹窗已显示
  emit('tooltip-shown')
}

const scheduleOpenTooltipIfNeeded = () => {
  const tooltipShown = localStorage.getItem('tooltipShown')
  if (tooltipShown || showTooltip.value || openTooltipTimer) {
    return
  }
  openTooltipTimer = setTimeout(() => {
    openTooltipTimer = null
    openTooltip()
  }, 1000)
}

// 关闭弹窗
const closeTooltip = async () => {
  showTooltip.value = false
  // 恢复背景滚动
  enableBodyScroll()
  // 可以在这里添加本地存储，记录用户已看过此提示
  localStorage.setItem('tooltipShown', 'true')
  try {
    // 调用updateDefaultStyle接口，设置默认风格为
    const userId = localStorage.getItem('wecom_external_userid')
    if (!userId) {
      throw new Error('未找到用户ID')
    }
    const defaultStyle = 1
    await updateDefaultStyle(userId, defaultStyle)
    localStorage.setItem('default_style', String(defaultStyle))
  } catch (error) {
    console.error('设置默认风格失败:', error)
  }
  // 通知父组件弹窗已关闭
  emit('tooltip-closed')
}

// 关闭弹窗
const closeModeltip = async () => {
  showTooltip.value = false
  // 恢复背景滚动
  enableBodyScroll()
  // 可以在这里添加本地存储，记录用户已看过此提示
  localStorage.setItem('tooltipShown', 'true')
  try {
    // 调用updateDefaultStyle接口，设置默认风格为
    const userId = localStorage.getItem('wecom_external_userid')
    if (!userId) {
      throw new Error('未找到用户ID')
    }
    const defaultStyle = selectedMode.value === 'simplified' ? 2 : 1
    await updateDefaultStyle(userId, defaultStyle)
    localStorage.setItem('default_style', String(defaultStyle))
  } catch (error) {
    console.error('设置默认风格失败:', error)
  }
  // 通知父组件弹窗已关闭
  emit('tooltip-closed')
}

const tryButton = (mode) => {
  selectedMode.value = mode
}

// 尝试详细版
const tryDetailedMode = () => {
  // 这里可以添加切换到详细版的逻辑
  selectedMode.value = 'detailed'
  closeModeltip()
}

// 尝试简化版
const trySimplifiedMode = () => {
  selectedMode.value = 'simplified'
  closeModeltip()
}

// 监听globalDefaultStyle的变化
watch(
  () => props.globalDefaultStyle,
  (newValue) => {
    if (newValue === null) {
      // 仅在首次且未显示过时尝试弹出
      scheduleOpenTooltipIfNeeded()
    }
  },
  { immediate: true },
)

// 组件挂载时检查是否需要显示弹窗
onMounted(() => {
  scheduleOpenTooltipIfNeeded()
})
// 组件卸载时恢复背景滚动
onBeforeUnmount(() => {
  if (openTooltipTimer) {
    clearTimeout(openTooltipTimer)
    openTooltipTimer = null
  }
  enableBodyScroll()
})
</script>

<style scoped>
.news-control {
  position: relative;
}

.tooltip-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1006;
}


.tooltip-content {
  background-color: white;
  border-radius: 12px;
  padding: 24px;
  max-width: 300px;
  width: 90%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  position: relative;
  top:-3%;
}

.tooltip-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.tooltip-icon {
  font-size: 24px;
  margin-right: 12px;
}

.tooltip-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.tooltip-description {
  margin-bottom: 24px;
  font-size: 14px;
  color: #666;
  line-height: 1.4;
}

.tooltip-modes {
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
}

.mode-card {
  flex: 1;
  padding: 16px;
  border-radius: 8px;
  text-align: center;
}

.detailed-mode {
  background-color: #f0f4f8;
}

.simplified-mode {
  background-color: #f8f0f4;
}

.mode-icon {
  font-size: 20px;
  margin-bottom: 8px;
}

.mode-card h4 {
  margin: 0 0 8px 0;
  font-size: 14px;
  font-weight: 600;
}

.mode-card p {
  margin: 0;
  font-size: 12px;
  color: #666;
  line-height: 1.3;
}

.tooltip-buttons {
  display: flex;
  gap: 12px;
}

.tooltip-buttons button {
  flex: 1;
  padding: 10px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.try-detailed-btn {
  background-color: #e6f7ff;
  color: #1890ff;
  border: 1px solid #91d5ff;
}

.try-detailed-btn:hover {
  background-color: #bae7ff;
}

.try-simplified-btn {
  background-color: #f6ffed;
  color: #52c41a;
  border: 1px solid #b7eb8f;
}

.try-simplified-btn:hover {
  background-color: #d9f7be;
}

.got-it-btn {
  background-color: #bae7ff;
}

.got-it-btn {
  background-color: #1890ff;
  color: white;
}

.got-it-btn:hover {
  background-color: #40a9ff;
}

.mode-card {
  cursor: pointer;
  transition: all 0.2s;
}

.detailed-mode:hover {
  background-color: #e6f7ff;
}

.simplified-mode:hover {
  background-color: #f6ffed;
}
</style>
